import { LineQuantityAdjust } from "@components/molecules/line-quantity-adjust/index.client";
import { usePostRequest } from "@models/interactions/get-single-product";
import { useLineItem } from "@models/interactions/use-line-item";
import { Markup } from "@components/atoms/markup/index.client";
import { Link, CartLinePrice, Image } from "@shopify/hydrogen";
import { CloseIcon } from "@components/atoms/Icons";
import { translate } from "@locales";
import classNames from "classnames";
import { CartLineItem } from "@models/interactions/cart-line-quantity-adjust";

export const LineItemPageMobile = () => {
  const { models, operations } = useLineItem();

  const barcode = usePostRequest(
    `api/single-product?handle=${models.merchandise.product.handle}`
  );
  return (
    <div className="hidden max-md:flex items-center justify-center w-[335px] border-2 py-5 mb-5">
      <div className="w-[308px]">
        <div key={models.lineId} className="flex flex-col">
          <div className="flex pb-5">
            <Image
              data={models?.merchandise?.image!}
              className="object-cover object-center w-[70px] h-[70px]"
              alt="product image"
            />
            <div className="w-[174px]">
              <h3 className="font-medium uppercase">
                <Link to={`/products/${models.merchandise.product.handle}`}>
                  {models.merchandise.product.title}
                </Link>
              </h3>
              <div className="text-dark-gray text-xs font-chivo-regular">
                <span>
                  # {translate("shop.product.item")}: {barcode}
                </span>
              </div>
              <Markup
                color="yellow"
                className={classNames("font-chivo-bold capitalize", {
                  hidden: !models.merchandise.availableForSale,
                })}
              >
                {translate("shop.filter.availability.in-stock")}
              </Markup>
            </div>
            <div className="pl-9">
              <button
                type="button"
                onClick={() => operations.linesRemove(models.lineId)}
                className="justify-self-start  w-0 h-0"
              >
                <CloseIcon className="font-medium" width="16" height="16" />
              </button>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-dark-gray text-base font-chivo-regular pl-2 flex items-center">
              ${models.merchandise.priceV2.amount}
            </span>
            <div className="flex items-center">
              <span>
                <CartLineItem />
              </span>
            </div>
            <CartLinePrice
              as="span"
              className="text-black font-chivo-regular font-medium text-xl tracking-wider"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
